// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"bf75dc58","container":"a2f1ae1c","subtitle":"da344a1d"};